<template>
	<Tree :data="data" :render="renderContent" class="ivue-tree">
	</Tree>
</template>

<script>
	export default {
		name: 'CsSideMenu',
		props: ['data', 'type'],
		data() {
			return {
				SelectClass: "ivu-tree-title ivu-tree-title-selected",
				DefineClass: "ivu-tree-title"
			}
		},
		methods: {
			//菜单排序
			//			sortTree(node, data) {
			//				this.expandedArr = [];
			//				let d = [node, data];
			//				this.$emit("onSort", d);
			//
			//			},
			renderContent(h, {
				root,
				node,
				data
			}) {
				if(node.node.selected) {
					return h(
						"span", {
							class: ["ivu-tree-span"],
							style: {
								display: "inline-block",
								width: "100%"
							},
							on: {
								click: () => {
									this.OnSelect(data);
									jq(".ivu-tree-title-selected").toggleClass("ivu-tree-title-selected");
									if(jq(event.target).isChildOf(".ivu-tree-title")) {
										event.target.parentNode.className = this.SelectClass;
									} else if(jq(event.target).isChildOf(".ivu-tree-span")) {
										event.target.className = this.SelectClass;
									} else if(jq(event.target).hasClass("ivu-tree-span")) {
										jq(event.target).find(".ivu-tree-title").toggleClass("ivu-tree-title-selected");
									}
								}
							}
						}, [
							h(
								"span", {
									class: ["ivu-tree-title", "ivu-tree-title-selected"],
									on: {
										click: event => {}
									}
								}, [
									h('Icon', {
										props: {
											type: 'ios-paper-outline'
										},
										style: {
											marginRight: '4px'
										}
									}),
									h('span', data.title),
									h('Icon', {
										props: {
											type: 'md-arrow-round-up',
										},
										style: {
											marginLeft: '5px',
											display: this.type == 'menu' ? 'inline-block' : 'none'
										},
										on: {
											click: () => {
												//												this.sortTree(node, data);
												this.expandedArr = [];
												let d = [node, data];
												this.$emit("onSort", d);
											}
										}
									})
								]
							)
						]
					);
				} else {
					return h(
						"span", {
							class: ["ivu-tree-span"],
							style: {
								display: "inline-block",
								width: "100%"
							},
							on: {
								click: (event) => {
									this.OnSelect(data);
									jq(".ivu-tree-title-selected").toggleClass("ivu-tree-title-selected");
									if(jq(event.target).isChildOf(".ivu-tree-title")) {
										event.target.parentNode.className = this.SelectClass;
									} else if(jq(event.target).isChildOf(".ivu-tree-span")) {
										event.target.className = this.SelectClass;
									} else if(jq(event.target).hasClass("ivu-tree-span")) {
										jq(event.target).find(".ivu-tree-title").toggleClass("ivu-tree-title-selected");
									}
								}
							}
						}, [
							h(
								"span", {
									class: ["ivu-tree-title"],
									on: {
										click: () => {}
									}
								}, [h('Icon', {
										props: {
											type: 'ios-paper-outline'
										},
										style: {
											marginRight: '4px'
										}
									}),
									h('span', data.title),
									h('Icon', {
										props: {
											type: 'md-arrow-round-up',
										},
										style: {
											marginLeft: '5px',
											display: this.type == 'menu' ? 'inline-block' : 'none'
										},
										on: {
											click: () => {
												this.expandedArr = [];
												let d = [node, data];
												this.$emit("onSort", d);
											}
										}
									})
								]
							)
						]
					);
				}
			},
			OnSelect(data) {
				this.$emit("OnSelectChange", data);
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/sideMenu/CsSideMenu.vue